import { BLACK, FEED_BACK, RED } from '../../../../theme/colorConstants';
import { fractionToPercent } from '../../../../utils/miscHelpers';

/**
 * Bands from highest to lowest. First tier where `percent >= minPercent` wins.
 * Adjust thresholds and colors here.
 */
export const RELIABILITY_SCORE_COLOR_TIERS = [
  {
    minPercent: 75,
    bgColor: FEED_BACK.GREEN_70,
    reportBgColor: FEED_BACK.GREEN_00,
    gradientStart: FEED_BACK.GREEN_70,
    gradientEnd: FEED_BACK.GREEN_80,
  },
  {
    minPercent: 50,
    bgColor: FEED_BACK.ORANGE_70,
    reportBgColor: FEED_BACK.ORANGE_00,
    gradientStart: FEED_BACK.ORANGE_50,
    gradientEnd: FEED_BACK.ORANGE_70,
  },
];

export const RELIABILITY_SCORE_LOW_BAND_COLORS = {
  bgColor: RED[70],
  reportBgColor: RED[0],
  gradientStart: RED[50],
  gradientEnd: RED[80],
};

export const RELIABILITY_SCORE_UNKNOWN_COLORS = {
  bgColor: BLACK[40],
  reportBgColor: BLACK[10],
  gradientStart: BLACK[40],
  gradientEnd: BLACK[60],
};

export const getReliabilityScorePercent = fractionToPercent;

export const getReliabilityScoreColors = (score) => {
  if (typeof score !== 'number') return RELIABILITY_SCORE_UNKNOWN_COLORS;
  const pct = fractionToPercent(score);
  const tier = RELIABILITY_SCORE_COLOR_TIERS.find((t) => pct >= t.minPercent);
  return tier ?? RELIABILITY_SCORE_LOW_BAND_COLORS;
};
